import { getDocs, collection } from "firebase/firestore";
import { db, auth } from "../../config/firebase";
import { useEffect, useState } from "react";
import { Post as PostView } from "../Post/Post";
import { useAuthState } from "react-firebase-hooks/auth";

export interface Post {
  id: string;
  userId: string;
  title: string;
  description: string;
  username: string;
  likeCount: number;
}

export const Home = () => {
  const [postsList, setPostsList] = useState<Post[] | null>();
  const postRef = collection(db, "posts");
  const [user, loading, error] = useAuthState(auth);
  const [loadingVisisble, setLoadingVisisble] = useState<boolean>(false);

  const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  let delayTime = 20;
  const getPosts = async () => {
    try {
      setLoadingVisisble(true);
      await delay(delayTime);
      const data = await getDocs(postRef);

      setPostsList(data.docs.map(doc => ({ ...doc.data(), id: doc.id })) as Post[]);
      setLoadingVisisble(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPosts();
  }, []);
  return (
    <div>
      <h1>Recent posts</h1>
      <div className='d-flex flex-column justify-content-center align-content-center mx-auto'>
        {postsList?.map(p => (
          <PostView post={p} refreshPosts={getPosts} />
        ))}
      </div>
      {loadingVisisble && (
        <div className='spinner-border my-2' role='status'>
          <span className='visually-hidden'>Loading...</span>
        </div>
      )}
      {!loadingVisisble && (
        <button
          className='btn btn-secondary my-3'
          onClick={() => {
            delayTime = 500;
            getPosts();
          }}>
          Refresh &#x21bb;
        </button>
      )}
    </div>
  );
};
